<template>
<div class="menu-wrapper">
    <div class="start">
        <router-link class="logo-wrapper" to="/">
            <img class="logo" alt="DOD logo." :src="require('@/assets/logo.jpg')" />
        </router-link>
        <router-link id="home" class="home-link"  to="/">
          Home
        </router-link>
    </div>
    <div class="end">
        <div class="animated links" :class="show_menu" :key="is_mobile_visible" @click="toggle_menu">
            <router-link class="link" v-for="(item, i) in navbar_items" :to="item.link" :key="i">
                {{item.title}}
            </router-link>
        </div>

        <div class="burger" @click="toggle_menu" :class="{'change': is_mobile_visible}">
            <div class="line one"></div>
            <div class="line two"></div>
            <div class="line three"></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            has_mobile_actived: false,
            is_mobile_visible: false,
            navbar_items: [
		  		{
					link: "/property-maintenance",
					title: "Property Maintenance",
          },
          {
					link: "/r2r-property",
					title: "R2R Property",
		  		},
		  		{
					link: "/landlord-services",
					title: "Landlord Services",
		  		},
		  		{
					link: "/contact",
					title: "Contact",
		  		},
            ],
            show_menu: {
                'is-visible': false
            },
        }
    },
    methods: {
        toggle_menu() {
            this.has_mobile_actived = !this.is_mobile_visible;
            this.is_mobile_visible = !this.is_mobile_visible;
            this.show_menu = { 
                'is-visible': this.has_mobile_actived
            }
            if (!this.has_mobile_actived) {
                window.scroll(0, 0);
            }
        }
    },
}
</script>

<style scoped>
.burger {
    display: none;
}

.burger .line {
    background-color: #000;
    margin: 0.5rem;
    height: 2px;
    transition: 0.4s;
    width: 2rem;
}

.end {
    height: 100%;
    margin-right: 1.5rem;
}

.home-link {
  margin-left: -0.25rem !important;
}

.logo {
  max-width: 10rem;
}

.link, .home-link {
    color: rgba(20, 20, 20, 0.95) !important;
    cursor: pointer;
    height: 100%;
    font-size: 1.2rem;
    font-weight: 250;
    margin: 0 0.5rem;
    text-decoration: none;
    padding: 1rem 1rem 0 1rem;
    padding-bottom: 5px;
    position: relative;
}

.link:after, .home-link:after, .start:hover >>> .home-link:after {
    background: #333;
    bottom: 0;
    content: "";
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
}

.link:hover, .home-link:hover, .start:hover >>> .home-link {
    background-color: #fafafa;
    color: rgba(20, 20, 20, 0.95) !important;
    cursor: pointer;
    text-decoration: none;
}

.link:hover:after, .home-link:hover:after, .start:hover >>> .home-link:after {
    left: 0;
    width: 100%;
}

.link i {
    color: #161823;
}

.links {
    display: flex;
    height: 100%;
}

.logo {
    height: 3.75rem;
    padding-left: 1rem;
}

.menu-wrapper {
    align-items: center;
    background-color: #FFF;
    display: flex;
    font-size: 16px;
    flex-direction: row;
    height: 3.8rem;
    justify-content: space-between; 
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 9999;
}

.navbar-item:after {
  bottom: 0;
  content: "";
  display: block;
  height: 2px;
  left: 50%;
  position: absolute;
  background: rgba(20, 20, 20, 0.95);
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0;
}

.start {
  display: flex;
  height: 100%;
}

.start .image {
    margin-left: 2rem;
    width: 70px;
}

/**
* MEDIA QUERIES
**/
@media only screen and (max-width: 768px) {
    .burger {
        display: inline-block;
        padding-top: 0.5rem;
    }

    .change .one {
        -webkit-transform: rotate(-45deg) translate(-9px, 6px);
        transform: rotate(-45deg) translate(-7px, 6px);
    }

    .change .two {
        opacity: 0;
    }

    .change .three {
        -webkit-transform: rotate(45deg) translate(-8px, -8px);
        transform: rotate(45deg) translate(-8px, -8px);
    }

    .end {
        margin-right: 0.5rem;
    }

    .is-fixed {
        position: fixed;
    }
    
    .link {
        border-bottom: solid 1px rgba(20, 20, 20, 0.95);
        height: calc((100vh - 3.5rem) / 4); /* 4 is N menu items */
        line-height: calc((100vh - 3.5rem) / 4);
        margin-left:0px;
        margin-right:0px;
    }

    .links {
        background-color: #FFF;
        flex-direction: column;
        font-size: 2rem;
        height: 100vh;
        left: 100vw;
        position: fixed;
        text-align: center;
        top: 3.3rem;
        transition: all 1s;
        width: 100vw;
        z-index: 1;
    }

    .links.is-visible {
        left: 0 !important;
    }

    .links .link {
        padding: 0rem;
        width: 100vw;
    }
}
@media only screen and (min-width: 769px) {
    .animated {
        animation-fill-mode: unset;
        -webkit-animation-fill-mode: unset;
    }
}
</style>
